import '@angoulemetourisme/scss/app-front-page.scss';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

import Utils from '@angoulemetourisme/js/services/utils';
import Slider from '@angoulemetourisme/js/services/slider';
import Form from '@angoulemetourisme/js/services/form';
import Menu from '@angoulemetourisme/js/services/menu';

document.addEventListener( "DOMContentLoaded", function () {

    //Utils.local_pictures();
    new Menu();

    // Utils
    Utils.click();
    Utils.bootstrap();
    Utils.searchbox();
    Utils.smooth_scroll();
    Utils.lazy();
    Utils.obfuscation();
    Utils.change_height_nav();
    Utils.hidding_toolbar();

    //Forms
    Form.dynamicLabel();
    
    // Slider
    Slider.hero();

    // Strates
    Slider.slider_blog();
    Slider.slider_carousel();
    Slider.slider_temps_forts();
    Slider.slider_rando();
    Slider.slider_agenda();

    initSlideRange();
    initSearchEngine();

     function initSlideRange() {
        if ($('#sliderRange').length > 0) {
            let rangeSlider = document.getElementById('sliderRange');
            // check if uislider is already build
            if(!$('#priceRange').hasClass('noUi-target')) {
                let minValue = $('#sliderRange').data('min-value');
                let maxValue = $('#sliderRange').data('max-value');
                let minValueDefault = minValue;
                let maxValueDefault = maxValue;

                // build range slider
                noUiSlider.create(rangeSlider, {
                    connect: true,
                    start: [minValueDefault, maxValueDefault],
                    range: {
                        'min': minValue,
                        'max': maxValue
                    }
                });

                rangeSlider.noUiSlider.on('update', function (values, handle) {
                    let min = Number(values[0]).toFixed(0);
                    let max = Number(values[1]).toFixed(0);

                    $('#sliderRangeMin').html(min + ' km');
                    $('#sliderRangeMax').html(max + ' km');

                    $('input[name="wpet_search[slider][distance][min]"]').val(min);
                    $('input[name="wpet_search[slider][distance][max]"]').val(max);
                });
            }
        }
    }

    function initSearchEngine(){
         let trigger = '[data-trigger="wpiris-engine-select-type"]';
         let engine = '[data-id="search-engine"]';

         if ( $( trigger ).length > 0 ) {
             $( trigger ).on( 'click', function ( e ) {
                 e.preventDefault();
                 $( this ).addClass( 'is-active' );
                 $( this ).siblings().removeClass( 'is-active' );
                 $( engine ).attr( 'action', $( this ).data( 'href' ) );
             } );
         }
    }

} );